import React from 'react';
import PropTypes from 'prop-types';
import { Button, withStyles } from '@material-ui/core';
import Loader from '../Loader';

const Fab = (props) => {
  const FabButton = withStyles((theme) => {
    const colors = {
      default: '#fdfdfd',
      accept: theme.palette.success.main,
      deny: theme.palette.error.main
    };

    return {
      root: {
        color: theme.palette.getContrastText(colors[props?.type]),
        background: colors[props?.type],
        transition: 'ease .3s',
        borderRadius: 50,
        fontSize: 16,
        height: 60,
        maxWidth: props.iconOnly ? 60 : 'max-content',
        minWidth: 60,
        width: props.iconOnly ? 60 : '100%',
        // fontWeight: 'bold',
        '&:hover': {
          // color: theme.palette.getContrastText(theme.palette.secondary.main),
          // backgroundColor: theme.palette.secondary.main,
          background: colors[props?.type]
        },
        '&.Mui-disabled': {
          background: theme.palette.grey.main
        }
      }
    };
  })(Button);

  return (
    <FabButton
      disabled={props.disabled}
      name={props.name}
      onClick={(e) => {
        e.stopPropagation();
        props.onClick();
      }}
      variant="contained"
      className={props.className}
      onTouchEnd={() => document.getElementsByName(props.name)[0].blur()}
    >
      {props.loading ? <Loader size={20} color={'inherit'} /> : props.children}
    </FabButton>
  );
};

Fab.propTypes = {
  type: PropTypes.oneOf(['default', 'accept', 'deny']),
  iconOnly: PropTypes.bool,
  className: PropTypes.string,
  name: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  children: PropTypes.node
};

Fab.defaultProps = {
  type: 'default',
  onClick: () => null
};

export default Fab;
